<template>

  <t-page>

    <t-page-list :title="'Listagem de ' + pageTitle.title" :user-auth="userAuth"
                 :total-pages="request.totalPages" :breadcrumb="breadcrumb" @getPage="getPage">

      CRIAR COMPONENTE CARDCHOISE para escolha agradável de opção antes de iniciar algum processo, por exemplo inclusão
      de NF, terá os tipos Vendas (saída) como principal, Saída variada (amostra gratis, etc), ou entrada variada
      (devolução do cliente, etc)
      COMPONENTE PLANO DE CONTA, SIMPLES SELEÇÃO E NAVEGAÇÃO COM BASE NA ABERTURA DOS PLANOS DE FORMA GRANDE E
      PESQUISÁVEL.

      <template #search>

        <t-button text="Incluir Nota Fiscal" to="sales-invoices-form" primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>

      </template>

      <b-table hover :items="request.content" :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.name" :userAuth="userAuth"/>
        </template>

        <template #cell(actions)>
          <t-list-actions-default :userAuth="userAuth"/>
        </template>

      </b-table>

    </t-page-list>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin";


export default {
  mixins: [pageDefaultMixin, pageListMixin],
  data() {
    return {
      fields: [
        {key: "first", label: "Nota Fiscal"},
        {key: "name", label: "Cliente"},
        {key: "example2", label: "Forma Recebimento"},
        {key: "example3", label: "Origem"},
        {key: "example4", label: "Natureza"},
        {key: "example5", label: "Data Cadastro"},
        {key: "example6", label: "Data Saída"},
        {key: "example7", label: "Valor Total"},
        {key: "example8", label: "Status"},
        {key: "actions", label: ""}
      ],
    }
  },
  methods: {},
  mounted() {


    /*
    * Mokado testes
    * ------------------------------------------------------------------ */

    const mokArray = []

    for (let i = 1; i < 15; i++) {
      mokArray.push(
          {
            "classId": i,
            "name": "Exemplo 1",
            "example2": "Texto",
            "example3": "Texto",
            "example4": "Texto",
            "example5": "Texto",
            "example6": "Texto",
            "example7": "Texto",
            "example8": "Texto"
          },
      )

    }

    this.request = {
      "content": mokArray
    }
    /*
    * ------------------------------------------------------------------ */

  },
  computed: {},

}
</script>
